<template>
  <div>
    <div v-show="divClass=='avatar-uploader'">
      <el-upload class="avatar-uploader" accept=".jpg,.jpeg,.png,.JPG,.JPEG"  :headers="myHeaders" :action="action"  :show-file-list="false"
        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <img v-if="imageUrl" :src="URL + imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        <div class="el-upload__tip" slot="tip">封面大小不超过2G</div>
      </el-upload>
    </div>
    <div v-show="divClass=='upload-demo'">
      <el-upload class="upload-demo"
      accept=".pdf,.PDF"
      drag
      ref="my-upload"
      :before-upload="uploaddemoUpload"
      :on-success="handleAvatarUpload"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :headers="myHeaders"
      :file-list="fileList"
      :show-file-list="true"
      :limit="1"
      :on-exceed="handleExceed"
      :action="action"
      multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传pdf文件，且不超过50MB</div>
      </el-upload>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Upload",
    props: {
      divClass: {
        type: String
      },
      imgurls: {
        type: String
      },
      pdfurls: {
        type: String
      },
      pdfnames:{
        type: String
      },
    },
    watch: {
      imgurls: {
        immediate: true,
        handler: function (val) {
          this.imageUrl =  val
        }
      },
      //pdf路径
      pdfurls: {
        immediate: true,
        handler: function (val) {
          if(val!=undefined){
          // console.log(val,'333333333')
          }
        }
      },
      //文件名字
      pdfnames: {
        immediate: true,
        handler: function (val) {
          this.fileList = []
          if(val!=undefined){
            this.fileList[0] = {name:val}
          }
        }
      },
    },
    data() {
      return {
        fileList: [],
        action: this.$URL + this.$api.periodicalupload, //上传地址
        imageUrl: '',
        URL: this.$URL, //图片URL
        myHeaders: { Authorization: "Bearer" + sessionStorage.getItem("token") }, // token
      }
    },
    computed: {

    },
    methods: {
      beforeRemove(file, fileList) {
        // return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemove(file, fileList) {
        this.$emit('remve')
        console.log(file, fileList,'111111111');
      },
      //上传成功后向父传值 IMG
      handleAvatarSuccess(res, file) {
        console.log('上传')
        this.$emit('Success',res.data)
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.imageUrl = res.data
      },
      //上传成功后向父传值 PDF
      handleAvatarUpload(res, file) {
        // this.$emit('Upload', {data:res.data,name:file.name})
        this.$emit('Upload',res.data)
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      // 文件类型限制
      beforeAvatarUpload(file) {
        console.log(file.type)
        const isJPG = file.type === 'image/jpeg' || 'image/png';
        const isLt2M = file.size / 1024 / 1024 / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 文件类型限制
      uploaddemoUpload(file) {
        // application/pdf
        const isPDF = file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 < 50;
        if (!isPDF) {
          this.$message.error('上传文件只能是 PDF 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 50MB!');
        }
        return isPDF && isLt2M;
      },
      //上传超出后提示
      handleExceed(files, fileList) {
        this.$message.warning(`只能上传一个噢~`);
      },
      //清除封面
      eliminateUrl() {
        this.imageUrl = ''
      },
      //清除PDF列表
      eliminatePdf() {
        this.fileList = []
        // this.$refs['my-upload'].clearFiles();
      }
    }
  }
</script>
<style lang="scss" scoped>
  /deep/.el-pagination {
    text-align: center;
    padding: 10px 0;
  }

  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 250px;
    height: 250px;
    line-height: 250px;
    text-align: center;
  }

  /deep/.avatar {
    width: 250px;
    height: 250px;
    display: block;
  }
</style>